"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleSemaphore = void 0;
/**
 * SimpleSemaphore is a basic semaphore implementation using promises.
 */
var SimpleSemaphore = /** @class */ (function () {
    /**
     * Useful for controlling access to a limited resource,
     *   allowing a certain number of concurrent operations.
     *
     * @param initial The initial count of the semaphore.
     */
    function SimpleSemaphore(initial) {
        this.waiting = [];
        this.counter = initial;
    }
    SimpleSemaphore.prototype.acquire = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this.counter > 0) {
                _this.counter--;
                resolve();
            }
            else {
                _this.waiting.push(resolve);
            }
        });
    };
    SimpleSemaphore.prototype.release = function () {
        this.counter++;
        if (this.waiting.length > 0) {
            var next = this.waiting.shift();
            next();
        }
    };
    return SimpleSemaphore;
}());
exports.SimpleSemaphore = SimpleSemaphore;
